<template>


<section class="kc-elm kc-css-311746 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-139045 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="bgrlabel kc-elm kc-css-422242 kc-pc-loaded" style="left:-380px;bottom:-60px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded wow animated bounceInLeft" data-wow-duration="2s" data-wow-delay="0s" data-src="@/assets/images/Frame-2.png" alt="" src="@/assets/images/Frame-2.png"></div>
                  </div>
               </div>
               <div class="ssc_mltttl  kc-elm kc-css-5484550 title_home show_msg" v-if="show_msg">
                  <div class="wr deb derb dea dera none nonea">
                    <img 
                     class=" ls-is-cached lazyloaded wow animated bounceInDown done"
                     data-wow-duration="2s" data-wow-delay="0s" 
                     data-src="@/assets/images/done.gif" alt="" 
                     src="@/assets/images/done.gif"
                    >
                    <slot name="thankstitle">
                     <h2 class="t1">Gracias por</h2>
                     <h2 class="t2">contactarse </h2>
                     <h2 class="t3">con nosotros</h2>
                    </slot>
                    <slot name="thankssubtitle">
                     <p class="t5">Su mensaje ha sido enviado correctamente. Nuestros representantes le responderán a la brevedad. Muchas gracias por contactarse con GlobalDev!</p>
                    </slot> 
                  </div>
               </div>
               <div class="ssc_mltttl  kc-elm kc-css-5484550 title_home" v-if="!show_msg">
                  <div class="wr deb derb dea dera none nonea">
                    <slot name="title">
                     <h2 class="t1">Get a </h2>
                     <h2 class="t2">free </h2>
                     <h2 class="t3">Prototype</h2>
                     <h2 class="t4">of Your Future Website!</h2>
                    </slot>
                    <slot name="subtitle">
                     <p class="t5">Send your requirements for a website, we will research your specification, create a prototype of the website for free and sed a result to you!</p>
                    </slot> 
                  </div>
               </div>
               <div class="ssc_caldf kc-elm kc-css-5877124 " v-if="!show_msg">
                  <div class="caldera-grid" id="caldera_form_2" >
                     <form class="CF5e0f463d7425b caldera_forms_form cfajax-trigger _tisBound">
                        <div  class="row  first_row">
                           <div class="col-sm-6  first_col">
                              <div  class="form-group">
                                 <label for="first_name" class="control-label screen-reader-text sr-only">First name</label>
                                 <div class="">
                                    <input v-model="first_name" :placeholder="$t('get_in_touch.text_6')" type="text" class=" form-control" required="required" name="first_name" >			
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6  first_col">
                              <div  class="form-group">
                                 <label for="last_name"  class="control-label screen-reader-text sr-only">Last name</label>
                                 <div class="">
                                    <input v-model="last_name" :placeholder="$t('get_in_touch.text_7')" type="text"  class=" form-control" required="required" name="last_name" >			
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6  first_col">
                              <div  class="form-group">
                                 <label for="email"  class="control-label screen-reader-text sr-only">Email</label>
                                 <div class="">
                                    <input v-model="email" :placeholder="$t('get_in_touch.text_8')" type="text"  class=" form-control" required="required" name="email" >			
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6  first_col">
                              <div  class="form-group">
                                 <label for="phone" class="control-label screen-reader-text sr-only">Phone</label>
                                 <div class="">
                                    <input v-model="phone" :placeholder="$t('get_in_touch.text_9')" type="text" class=" form-control" required="required" name="phone" >			
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="CF5e0f463d7425b_2-row-2" class="row ">
                           <div class="col-sm-12  single">
                              <div  class="form-group" >
                                 <label for="message" class="control-label screen-reader-text sr-only">Message</label>
                                 <div class="">
                                    <textarea v-model="message" name="message" value="" rows="3" :placeholder="$t('get_in_touch.text_10')" required="required" aria-labelledby="fld_3955398Label"></textarea>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="CF5e0f463d7425b_2-row-3" class="row  last_row">
                           <div class="col-sm-12  single">
                              <div data-field-wrapper="fld_1739855" class="form-group" >
                                 <div class="">
                                    <img v-if="loading" src="../../assets/images/spinner.gif" style="width: 65px;"/>
                                    <vue-recaptcha v-if="!loading" sitekey="6Lfa3aYaAAAAALZyW10rTZ3JidMk3dYADYFOL0Ow" :loadRecaptchaScript="true">
                                       <input type="submit" v-on:click="sendEmail" class="btn btn-default" name="submit" :value="$t('get_in_touch.text_11')">
                                    </vue-recaptcha>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
               <div class="bgrlabel kc-elm kc-css-469547 kc-pc-loaded" style="bottom:-113px;right:-370px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded wow animated bounceInRight" data-wow-duration="2s" data-wow-delay="0s" data-src="../../assets/images/Frame-4.png" alt="" src="../../assets/images/Frame-4.png"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
import emailjs from 'emailjs-com';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "GetInTouch",
  props: ["title", "subtitle", "header"],
  components: { VueRecaptcha },
  data() {
    return {
      msg: "GetInTouch",
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      message: '',
      show_msg: false,
      loading: false
    };
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    sendEmail(e) {
       try {
          if (
             this.first_name != '' && 
            this.last_name != '' && 
            this.email != '' && 
            this.phone != '' && 
            this.message != ''
         ){
            this.loading = true
            this.sleep(2000).then(() => { 
               this.show_msg = true

               emailjs.send('service_l51ei4m', 'template_azrs2lh', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone: this.phone,
                message: this.message
               },
               'user_IbFS8lv50rVzyFH4VPjK4')

               // // Reset form field
               this.first_name= ''
               this.last_name= ''
               this.email= ''
               this.phone= ''
               this.message= ''
               this.loading = false
            });


         }

      } catch(error) {
          console.log({error})
      }
      
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.done{
   width: 6%;
   display: block;
   margin: 13px auto;
}
.show_msg{
   min-height: 200px;
}
@media all{
.screen-reader-text{clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute!important;width:1px;word-wrap:normal!important;}
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_column{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container{height:100%;}
.kingcomposer div.kc_column{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column{width:100%;}
}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
input,textarea{margin:0;}
input[type="submit"]{-webkit-appearance:button;cursor:pointer;}
input::-moz-focus-inner{border:0;padding:0;}
input{line-height:normal;}
textarea{overflow:auto;}
.screen-reader-text{clip:rect(1px,1px,1px,1px);position:absolute!important;height:1px;width:1px;overflow:hidden;}
.screen-reader-text:focus{background-color:#f1f1f1;border-radius:3px;box-shadow:0 0 2px 2px rgba(0,0,0,.6);clip:auto!important;color:#21759b;display:block;font-size:14px;font-size:.875rem;font-weight:700;height:auto;left:5px;line-height:normal;padding:15px 23px 14px;text-decoration:none;top:5px;width:auto;z-index:100000;}
input,textarea{font-family:"Catamaran";font-size:16px;line-height:1.5;border:0;outline:none;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
input[type="text"],input[type="submit"],input[type="tel"],html body textarea{background-color:rgba(116,131,190,.2);color:rgba(126,131,153,1);border-radius:50px;border-width:1px 1px 1px 1px;border-style:solid;border-color:#e5e6eb;height:50px;line-height:50px;box-sizing:border-box;outline:none;max-width:100%;}
html body textarea{line-height:26px;}
input[type="text"]:focus,input[type="tel"]:focus,html body textarea:focus{color:#333;border-color:rgba(243,84,68,1);}
input[type="text"],input[type="submit"],input[type="tel"]{padding:0 18px;}
html body textarea{padding:11px 15px;height:100px;width:100%;}
input[type="text"]::-webkit-input-placeholder,input[type="tel"]::-webkit-input-placeholder,html body textarea::-webkit-input-placeholder,input[type="text"]::-moz-placeholder,input[type="tel"]::-moz-placeholder,html body textarea::-moz-placeholder,input[type="text"]:-moz-placeholder,input[type="tel"]:-moz-placeholder,html body textarea:-moz-placeholder,input[type="text"]:-ms-input-placeholder,input[type="tel"]:-ms-input-placeholder,html body textarea:-ms-input-placeholder{color:#b2b9be;}
main input[type="submit"]{display:block;border-radius:50px;border-width:2px 2px 2px 2px;border-style:solid;border-color:#ED7D31;background-color:rgba(245,94,102,0);box-shadow:none;color:rgba(34,34,34,1);font-size:14px;text-transform:uppercase;padding:0 40px;text-shadow:none;line-height:44px;outline:none;font-weight:700;outline:0;margin:0 auto;}
main input[type="submit"]:hover{color:rgba(255,255,255,1);box-shadow:none;background-color:rgba(243,84,68,1);border-width:2px 2px 2px 2px;border-style:solid;border-color:#ED7D31;}
ul{margin:0 0 1.5em 1em;}
ul{list-style:disc;}
*,*:before,*:after{box-sizing:inherit;}
img{height:auto;max-width:100%;}
.row:before,.row:after{content:" ";display:table;}
.row:after{clear:both;}
.row{margin-left:-15px;margin-right:-15px;}
.col-sm-6,.col-sm-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px;}
@media (min-width:768px){
.col-sm-6,.col-sm-12{float:left;}
.col-sm-12{width:100%;}
.col-sm-6{width:50%;}
}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:768px){
ul{margin:0 0 1.5em 1em;}
input[type="text"],input[type="tel"],textarea{width:100%;}
main input[type="submit"]{max-width:100%;white-space:normal;}
}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
@media screen and (max-width:540px){
ul{margin:0 0 1.5em 0;}
}
.caldera-grid *,.caldera-grid :after,.caldera-grid :before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
.caldera-grid input,.caldera-grid textarea{font-family:inherit;font-size:inherit;line-height:inherit;}
.caldera-grid .sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;}
.caldera-grid .row{margin-left:-7.5px;margin-right:-7.5px;}
.caldera-grid .col-sm-12,.caldera-grid .col-sm-6{position:relative;padding-left:7.5px;padding-right:7.5px;}
@media (min-width:768px){
.caldera-grid .col-sm-12,.caldera-grid .col-sm-6{float:left;}
.caldera-grid .col-sm-12{width:100%;}
.caldera-grid .col-sm-6{width:50%;}
}
.caldera-grid .row:after,.caldera-grid .row:before{content:" ";display:table;}
.caldera-grid .row:after{clear:both;}
.caldera-grid .hide{display:none!important;}
.caldera-grid textarea{overflow:auto;}
.caldera-grid input,.caldera-grid textarea{font:inherit;margin:0;}
.caldera-grid input[type=submit]{-webkit-appearance:button;cursor:pointer;}
.caldera-grid input::-moz-focus-inner{border:0;padding:0;}
.caldera-grid input{line-height:normal;}
@media print{
.caldera-grid *,.caldera-grid :after,.caldera-grid :before{background:0 0!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
}
.caldera-grid .btn,.caldera-grid .btn-default:active,.caldera-grid .btn:active,.caldera-grid .form-control{background-image:none;}
.caldera-grid label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700;}
.caldera-grid .form-group{margin-bottom:15px;}
.caldera-grid .form-control{font-size:14px;line-height:1.42857143;color:#555;display:block;}
.caldera-grid .form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;border:1px solid #ccc;border-radius:2px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;}
.caldera-grid .form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);}
.caldera-grid .form-control::-moz-placeholder{color:#999;opacity:1;}
.caldera-grid .form-control:-ms-input-placeholder{color:#999;}
.caldera-grid .form-control::-webkit-input-placeholder{color:#999;}
.caldera-grid .btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
.caldera-grid .btn:active:focus,.caldera-grid .btn:focus{outline:dotted thin;outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px;}
.caldera-grid .btn:focus,.caldera-grid .btn:hover{color:#333;text-decoration:none;}
.caldera-grid .btn:active{outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125);}
.caldera-grid .btn-default{color:#333;background-color:#fff;border-color:#ccc;}
.caldera-grid .btn-default:active,.caldera-grid .btn-default:focus,.caldera-grid .btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad;}
.caldera-grid textarea.form-control{padding-right:4px;height:auto;}
.caldera-grid .screen-reader-text{clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute!important;width:1px;word-wrap:normal!important;}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.intl-tel-input{width:100%;}
.caldera-grid{width:100%;}
body .intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:rgba(0,0,0,0);}
body .caldera-grid .form-group{margin-bottom:0;width:100%;}
.ssc_caldf{clear:both;}
body.kc-css-system .caldera-grid input[type="submit"]{width:auto;transition:all 300ms;}
body.kc-css-system .caldera-grid textarea{overflow:hidden;resize:none;}
body .caldera-grid .form-control{-webkit-box-shadow:none;box-shadow:none;}
body .intl-tel-input.allow-dropdown .selected-flag{width:52px;}
.intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:transparent;}
body .intl-tel-input .selected-flag{padding:0 0 0 14px;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.intl-tel-input{position:relative;display:inline-block;}
.intl-tel-input *{box-sizing:border-box;-moz-box-sizing:border-box;}
.intl-tel-input .hide{display:none;}
.intl-tel-input input,.intl-tel-input input[type=tel]{position:relative;z-index:0;margin-top:0!important;margin-bottom:0!important;padding-right:36px;margin-right:0;}
.intl-tel-input .flag-container{position:absolute;top:0;bottom:0;right:0;padding:1px;}
.intl-tel-input .selected-flag{z-index:1;position:relative;width:36px;height:100%;padding:0 0 0 8px;}
.intl-tel-input .selected-flag .iti-flag{position:absolute;top:0;bottom:0;margin:auto;}
.intl-tel-input .selected-flag .iti-arrow{position:absolute;top:50%;margin-top:-2px;right:6px;width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid #555;}
.intl-tel-input .country-list{position:absolute;z-index:2;list-style:none;text-align:left;padding:0;margin:0 0 0 -1px;box-shadow:1px 1px 4px rgba(0,0,0,.2);background-color:#fff;border:1px solid #CCC;white-space:nowrap;max-height:200px;overflow-y:scroll;}
.intl-tel-input .country-list .flag-box{display:inline-block;width:20px;}
@media (max-width:500px){
.intl-tel-input .country-list{white-space:normal;}
}
.intl-tel-input .country-list .divider{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid #CCC;}
.intl-tel-input .country-list .country{padding:5px 10px;}
.intl-tel-input .country-list .country .dial-code{color:#999;}
.intl-tel-input .country-list .flag-box,.intl-tel-input .country-list .country-name,.intl-tel-input .country-list .dial-code{vertical-align:middle;}
.intl-tel-input .country-list .flag-box,.intl-tel-input .country-list .country-name{margin-right:6px;}
.intl-tel-input.allow-dropdown input,.intl-tel-input.allow-dropdown input[type=tel]{padding-right:6px;padding-left:52px;margin-left:0;}
.intl-tel-input.allow-dropdown .flag-container{right:auto;left:0;}
.intl-tel-input.allow-dropdown .selected-flag{width:46px;}
.intl-tel-input.allow-dropdown .flag-container:hover{cursor:pointer;}
.intl-tel-input.allow-dropdown .flag-container:hover .selected-flag{background-color:rgba(0,0,0,.05);}
.iti-flag{width:20px;}
.iti-flag.be{width:18px;}
.iti-flag.ch{width:15px;}
.iti-flag.mc{width:19px;}
.iti-flag.ne{width:18px;}
.iti-flag.np{width:13px;}
.iti-flag.va{width:15px;}
@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (-o-min-device-pixel-ratio:2 / 1),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){
.iti-flag{background-size:5630px 15px;}
}
.iti-flag.ad{height:14px;background-position:-22px 0;}
.iti-flag.ae{height:10px;background-position:-44px 0;}
.iti-flag.af{height:14px;background-position:-66px 0;}
.iti-flag.ag{height:14px;background-position:-88px 0;}
.iti-flag.ai{height:10px;background-position:-110px 0;}
.iti-flag.al{height:15px;background-position:-132px 0;}
.iti-flag.am{height:10px;background-position:-154px 0;}
.iti-flag.ao{height:14px;background-position:-176px 0;}
.iti-flag.ar{height:13px;background-position:-220px 0;}
.iti-flag.as{height:10px;background-position:-242px 0;}
.iti-flag.at{height:14px;background-position:-264px 0;}
.iti-flag.au{height:10px;background-position:-286px 0;}
.iti-flag.aw{height:14px;background-position:-308px 0;}
.iti-flag.ax{height:13px;background-position:-330px 0;}
.iti-flag.az{height:10px;background-position:-352px 0;}
.iti-flag.ba{height:10px;background-position:-374px 0;}
.iti-flag.bb{height:14px;background-position:-396px 0;}
.iti-flag.bd{height:12px;background-position:-418px 0;}
.iti-flag.be{height:15px;background-position:-440px 0;}
.iti-flag.bf{height:14px;background-position:-460px 0;}
.iti-flag.bg{height:12px;background-position:-482px 0;}
.iti-flag.bh{height:12px;background-position:-504px 0;}
.iti-flag.bi{height:12px;background-position:-526px 0;}
.iti-flag.bj{height:14px;background-position:-548px 0;}
.iti-flag.bl{height:14px;background-position:-570px 0;}
.iti-flag.bm{height:10px;background-position:-592px 0;}
.iti-flag.bn{height:10px;background-position:-614px 0;}
.iti-flag.bo{height:14px;background-position:-636px 0;}
.iti-flag.bq{height:14px;background-position:-658px 0;}
.iti-flag.br{height:14px;background-position:-680px 0;}
.iti-flag.bs{height:10px;background-position:-702px 0;}
.iti-flag.bt{height:14px;background-position:-724px 0;}
.iti-flag.bw{height:14px;background-position:-768px 0;}
.iti-flag.by{height:10px;background-position:-790px 0;}
.iti-flag.bz{height:14px;background-position:-812px 0;}
.iti-flag.ca{height:10px;background-position:-834px 0;}
.iti-flag.cc{height:10px;background-position:-856px 0;}
.iti-flag.cd{height:15px;background-position:-878px 0;}
.iti-flag.cf{height:14px;background-position:-900px 0;}
.iti-flag.cg{height:14px;background-position:-922px 0;}
.iti-flag.ch{height:15px;background-position:-944px 0;}
.iti-flag.ci{height:14px;background-position:-961px 0;}
.iti-flag.ck{height:10px;background-position:-983px 0;}
.iti-flag.cl{height:14px;background-position:-1005px 0;}
.iti-flag.cm{height:14px;background-position:-1027px 0;}
.iti-flag.cn{height:14px;background-position:-1049px 0;}
.iti-flag.co{height:14px;background-position:-1071px 0;}
.iti-flag.cr{height:12px;background-position:-1115px 0;}
.iti-flag.cu{height:10px;background-position:-1137px 0;}
.iti-flag.cv{height:12px;background-position:-1159px 0;}
.iti-flag.cw{height:14px;background-position:-1181px 0;}
.iti-flag.cx{height:10px;background-position:-1203px 0;}
.iti-flag.cy{height:13px;background-position:-1225px 0;}
.iti-flag.cz{height:14px;background-position:-1247px 0;}
.iti-flag.de{height:12px;background-position:-1269px 0;}
.iti-flag.dj{height:14px;background-position:-1313px 0;}
.iti-flag.dk{height:15px;background-position:-1335px 0;}
.iti-flag.dm{height:10px;background-position:-1357px 0;}
.iti-flag.do{height:13px;background-position:-1379px 0;}
.iti-flag.dz{height:14px;background-position:-1401px 0;}
.iti-flag.ec{height:14px;background-position:-1445px 0;}
.iti-flag.ee{height:13px;background-position:-1467px 0;}
.iti-flag.eg{height:14px;background-position:-1489px 0;}
.iti-flag.eh{height:10px;background-position:-1511px 0;}
.iti-flag.er{height:10px;background-position:-1533px 0;}
.iti-flag.es{height:14px;background-position:-1555px 0;}
.iti-flag.et{height:10px;background-position:-1577px 0;}
.iti-flag.fi{height:12px;background-position:-1621px 0;}
.iti-flag.fj{height:10px;background-position:-1643px 0;}
.iti-flag.fk{height:10px;background-position:-1665px 0;}
.iti-flag.fm{height:11px;background-position:-1687px 0;}
.iti-flag.fo{height:15px;background-position:-1709px 0;}
.iti-flag.fr{height:14px;background-position:-1731px 0;}
.iti-flag.ga{height:15px;background-position:-1753px 0;}
.iti-flag.gb{height:10px;background-position:-1775px 0;}
.iti-flag.gd{height:12px;background-position:-1797px 0;}
.iti-flag.ge{height:14px;background-position:-1819px 0;}
.iti-flag.gf{height:14px;background-position:-1841px 0;}
.iti-flag.gg{height:14px;background-position:-1863px 0;}
.iti-flag.gh{height:14px;background-position:-1885px 0;}
.iti-flag.gi{height:10px;background-position:-1907px 0;}
.iti-flag.gl{height:14px;background-position:-1929px 0;}
.iti-flag.gm{height:14px;background-position:-1951px 0;}
.iti-flag.gn{height:14px;background-position:-1973px 0;}
.iti-flag.gp{height:14px;background-position:-1995px 0;}
.iti-flag.gq{height:14px;background-position:-2017px 0;}
.iti-flag.gr{height:14px;background-position:-2039px 0;}
.iti-flag.gt{height:13px;background-position:-2083px 0;}
.iti-flag.gu{height:11px;background-position:-2105px 0;}
.iti-flag.gw{height:10px;background-position:-2127px 0;}
.iti-flag.gy{height:12px;background-position:-2149px 0;}
.iti-flag.hk{height:14px;background-position:-2171px 0;}
.iti-flag.hn{height:10px;background-position:-2215px 0;}
.iti-flag.hr{height:10px;background-position:-2237px 0;}
.iti-flag.ht{height:12px;background-position:-2259px 0;}
.iti-flag.hu{height:10px;background-position:-2281px 0;}
.iti-flag.id{height:14px;background-position:-2325px 0;}
.iti-flag.ie{height:10px;background-position:-2347px 0;}
.iti-flag.il{height:15px;background-position:-2369px 0;}
.iti-flag.im{height:10px;background-position:-2391px 0;}
.iti-flag.in{height:14px;background-position:-2413px 0;}
.iti-flag.io{height:10px;background-position:-2435px 0;}
.iti-flag.iq{height:14px;background-position:-2457px 0;}
.iti-flag.ir{height:12px;background-position:-2479px 0;}
.iti-flag.is{height:15px;background-position:-2501px 0;}
.iti-flag.it{height:14px;background-position:-2523px 0;}
.iti-flag.je{height:12px;background-position:-2545px 0;}
.iti-flag.jm{height:10px;background-position:-2567px 0;}
.iti-flag.jo{height:10px;background-position:-2589px 0;}
.iti-flag.jp{height:14px;background-position:-2611px 0;}
.iti-flag.ke{height:14px;background-position:-2633px 0;}
.iti-flag.kg{height:12px;background-position:-2655px 0;}
.iti-flag.kh{height:13px;background-position:-2677px 0;}
.iti-flag.ki{height:10px;background-position:-2699px 0;}
.iti-flag.km{height:12px;background-position:-2721px 0;}
.iti-flag.kn{height:14px;background-position:-2743px 0;}
.iti-flag.kp{height:10px;background-position:-2765px 0;}
.iti-flag.kr{height:14px;background-position:-2787px 0;}
.iti-flag.kw{height:10px;background-position:-2809px 0;}
.iti-flag.ky{height:10px;background-position:-2831px 0;}
.iti-flag.kz{height:10px;background-position:-2853px 0;}
.iti-flag.la{height:14px;background-position:-2875px 0;}
.iti-flag.lb{height:14px;background-position:-2897px 0;}
.iti-flag.lc{height:10px;background-position:-2919px 0;}
.iti-flag.li{height:12px;background-position:-2941px 0;}
.iti-flag.lk{height:10px;background-position:-2963px 0;}
.iti-flag.lr{height:11px;background-position:-2985px 0;}
.iti-flag.ls{height:14px;background-position:-3007px 0;}
.iti-flag.lt{height:12px;background-position:-3029px 0;}
.iti-flag.lu{height:12px;background-position:-3051px 0;}
.iti-flag.lv{height:10px;background-position:-3073px 0;}
.iti-flag.ly{height:10px;background-position:-3095px 0;}
.iti-flag.ma{height:14px;background-position:-3117px 0;}
.iti-flag.mc{height:15px;background-position:-3139px 0;}
.iti-flag.md{height:10px;background-position:-3160px 0;}
.iti-flag.me{height:10px;background-position:-3182px 0;}
.iti-flag.mf{height:14px;background-position:-3204px 0;}
.iti-flag.mg{height:14px;background-position:-3226px 0;}
.iti-flag.mh{height:11px;background-position:-3248px 0;}
.iti-flag.mk{height:10px;background-position:-3270px 0;}
.iti-flag.ml{height:14px;background-position:-3292px 0;}
.iti-flag.mm{height:14px;background-position:-3314px 0;}
.iti-flag.mn{height:10px;background-position:-3336px 0;}
.iti-flag.mo{height:14px;background-position:-3358px 0;}
.iti-flag.mp{height:10px;background-position:-3380px 0;}
.iti-flag.mq{height:14px;background-position:-3402px 0;}
.iti-flag.mr{height:14px;background-position:-3424px 0;}
.iti-flag.ms{height:10px;background-position:-3446px 0;}
.iti-flag.mt{height:14px;background-position:-3468px 0;}
.iti-flag.mu{height:14px;background-position:-3490px 0;}
.iti-flag.mv{height:14px;background-position:-3512px 0;}
.iti-flag.mw{height:14px;background-position:-3534px 0;}
.iti-flag.mx{height:12px;background-position:-3556px 0;}
.iti-flag.my{height:10px;background-position:-3578px 0;}
.iti-flag.mz{height:14px;background-position:-3600px 0;}
.iti-flag.na{height:14px;background-position:-3622px 0;}
.iti-flag.nc{height:10px;background-position:-3644px 0;}
.iti-flag.ne{height:15px;background-position:-3666px 0;}
.iti-flag.nf{height:10px;background-position:-3686px 0;}
.iti-flag.ng{height:10px;background-position:-3708px 0;}
.iti-flag.ni{height:12px;background-position:-3730px 0;}
.iti-flag.nl{height:14px;background-position:-3752px 0;}
.iti-flag.no{height:15px;background-position:-3774px 0;}
.iti-flag.np{height:15px;background-position:-3796px 0;}
.iti-flag.nr{height:10px;background-position:-3811px 0;}
.iti-flag.nu{height:10px;background-position:-3833px 0;}
.iti-flag.nz{height:10px;background-position:-3855px 0;}
.iti-flag.om{height:10px;background-position:-3877px 0;}
.iti-flag.pa{height:14px;background-position:-3899px 0;}
.iti-flag.pe{height:14px;background-position:-3921px 0;}
.iti-flag.pf{height:14px;background-position:-3943px 0;}
.iti-flag.pg{height:15px;background-position:-3965px 0;}
.iti-flag.ph{height:10px;background-position:-3987px 0;}
.iti-flag.pk{height:14px;background-position:-4009px 0;}
.iti-flag.pl{height:13px;background-position:-4031px 0;}
.iti-flag.pm{height:14px;background-position:-4053px 0;}
.iti-flag.pr{height:14px;background-position:-4097px 0;}
.iti-flag.ps{height:10px;background-position:-4119px 0;}
.iti-flag.pt{height:14px;background-position:-4141px 0;}
.iti-flag.pw{height:13px;background-position:-4163px 0;}
.iti-flag.py{height:11px;background-position:-4185px 0;}
.iti-flag.qa{height:8px;background-position:-4207px 0;}
.iti-flag.re{height:14px;background-position:-4229px 0;}
.iti-flag.ro{height:14px;background-position:-4251px 0;}
.iti-flag.rs{height:14px;background-position:-4273px 0;}
.iti-flag.ru{height:14px;background-position:-4295px 0;}
.iti-flag.rw{height:14px;background-position:-4317px 0;}
.iti-flag.sa{height:14px;background-position:-4339px 0;}
.iti-flag.sb{height:10px;background-position:-4361px 0;}
.iti-flag.sc{height:10px;background-position:-4383px 0;}
.iti-flag.sd{height:10px;background-position:-4405px 0;}
.iti-flag.se{height:13px;background-position:-4427px 0;}
.iti-flag.sg{height:14px;background-position:-4449px 0;}
.iti-flag.sh{height:10px;background-position:-4471px 0;}
.iti-flag.si{height:10px;background-position:-4493px 0;}
.iti-flag.sj{height:15px;background-position:-4515px 0;}
.iti-flag.sk{height:14px;background-position:-4537px 0;}
.iti-flag.sl{height:14px;background-position:-4559px 0;}
.iti-flag.sm{height:15px;background-position:-4581px 0;}
.iti-flag.sn{height:14px;background-position:-4603px 0;}
.iti-flag.so{height:14px;background-position:-4625px 0;}
.iti-flag.sr{height:14px;background-position:-4647px 0;}
.iti-flag.ss{height:10px;background-position:-4669px 0;}
.iti-flag.st{height:10px;background-position:-4691px 0;}
.iti-flag.sv{height:12px;background-position:-4713px 0;}
.iti-flag.sx{height:14px;background-position:-4735px 0;}
.iti-flag.sy{height:14px;background-position:-4757px 0;}
.iti-flag.sz{height:14px;background-position:-4779px 0;}
.iti-flag.tc{height:10px;background-position:-4823px 0;}
.iti-flag.td{height:14px;background-position:-4845px 0;}
.iti-flag.tg{height:13px;background-position:-4889px 0;}
.iti-flag.th{height:14px;background-position:-4911px 0;}
.iti-flag.tj{height:10px;background-position:-4933px 0;}
.iti-flag.tk{height:10px;background-position:-4955px 0;}
.iti-flag.tl{height:10px;background-position:-4977px 0;}
.iti-flag.tm{height:14px;background-position:-4999px 0;}
.iti-flag.tn{height:14px;background-position:-5021px 0;}
.iti-flag.to{height:10px;background-position:-5043px 0;}
.iti-flag.tr{height:14px;background-position:-5065px 0;}
.iti-flag.tt{height:12px;background-position:-5087px 0;}
.iti-flag.tv{height:10px;background-position:-5109px 0;}
.iti-flag.tw{height:14px;background-position:-5131px 0;}
.iti-flag.tz{height:14px;background-position:-5153px 0;}
.iti-flag.ua{height:14px;background-position:-5175px 0;}
.iti-flag.ug{height:14px;background-position:-5197px 0;}
.iti-flag.us{height:11px;background-position:-5241px 0;}
.iti-flag.uy{height:14px;background-position:-5263px 0;}
.iti-flag.uz{height:10px;background-position:-5285px 0;}
.iti-flag.va{height:15px;background-position:-5307px 0;}
.iti-flag.vc{height:14px;background-position:-5324px 0;}
.iti-flag.ve{height:14px;background-position:-5346px 0;}
.iti-flag.vg{height:10px;background-position:-5368px 0;}
.iti-flag.vi{height:14px;background-position:-5390px 0;}
.iti-flag.vn{height:14px;background-position:-5412px 0;}
.iti-flag.vu{height:12px;background-position:-5434px 0;}
.iti-flag.wf{height:14px;background-position:-5456px 0;}
.iti-flag.ws{height:10px;background-position:-5478px 0;}
.iti-flag.xk{height:15px;background-position:-5500px 0;}
.iti-flag.ye{height:14px;background-position:-5522px 0;}
.iti-flag.yt{height:14px;background-position:-5544px 0;}
.iti-flag.za{height:14px;background-position:-5566px 0;}
.iti-flag.zm{height:14px;background-position:-5588px 0;}
.iti-flag.zw{height:10px;background-position:-5610px 0;}
.iti-flag{width:20px;height:15px;box-shadow:0 0 1px 0 #888;background-image:url(../../assets/images/flags.png);background-repeat:no-repeat;background-color:#DBDBDB;background-position:20px 0;}
@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (-o-min-device-pixel-ratio:2 / 1),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){
.iti-flag{background-image:url(../../assets/images/flags.png);}
}
.iti-flag.np{background-color:transparent;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t5{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
main input[type="submit"]{padding-top:0px;padding-right:50px;padding-bottom:0px;padding-left:50px;}
main input[type="submit"]{border-top:2px solid #ED7D31;border-bottom:2px solid #ED7D31;border-left:2px solid #ED7D31;border-right:2px solid #ED7D31;}
input[type="text"],input[type="tel"],html body textarea{border-top:1px solid #e5e6eb;border-bottom:1px solid #e5e6eb;border-left:1px solid #e5e6eb;border-right:1px solid #e5e6eb;}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
body.kc-css-system .kc-css-311746{background:#151823 url(../../assets/images/bak_form.png) center center/cover no-repeat scroll;padding-top:123px;padding-bottom:105px;}
body.kc-css-system .kc-css-5484550.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-5484550{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-5484550 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:475px;}
body.kc-css-system .kc-css-5484550 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:475px;}
body.kc-css-system .kc-css-5484550 .t1{color:#ffffff;text-align:center;text-transform:none;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t2{color:#ED7D31;text-transform:full-size-kana;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t3{color:#ffffff;text-transform:none;line-height:39px;display:inline;}
body.kc-css-system .kc-css-5484550 .t4{color:#ffffff;text-align:center;text-transform:none;line-height:39px;margin-top:10px;}
body.kc-css-system .kc-css-5484550 .t5{color:#ffffff;padding-top:10px;padding-right:23%;padding-left:23%;}
body.kc-css-system .kc-css-5877124{text-align:center;float:none;max-width:580px;margin-right:auto;margin-left:auto;padding-top:45px;}
/* body.kc-css-system .kc-css-5877124 .caldera-grid .row > div{padding-right:15px;} */
body.kc-css-system .kc-css-5877124 label{color:#949494;}
body.kc-css-system .kc-css-5877124 input{color:#ffffff;background:#151823;font-family:Catamaran;font-size:15px;line-height:29px;font-weight:400;text-align:left;width:100%;height:50px;border:1px solid #9296a4;border-radius:30px 30px 30px 30px;margin-bottom:15px;padding-top:0px;padding-bottom:0px;padding-left:30px;}
body.kc-css-system .kc-css-5877124 textarea{color:#ffffff;background:#151823;font-size:15px;line-height:35px;font-weight:400;border:1px solid #7e8399;border-radius:20px 20px 20px 20px;margin-top:10px;margin-bottom:25px;padding-top:5px;padding-left:30px;}
body.kc-css-system .kc-css-5877124 input::-webkit-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input::-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input:-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 input:-ms-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea::-webkit-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea::-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea:-moz-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 textarea:-ms-input-placeholder{color:#ffffff;}
body.kc-css-system .kc-css-5877124 .caldera-grid input.btn{color:#ffffff;background:rgba(255, 255, 255, 0);height:45px;font-size:16px;line-height:27px;font-weight:500;text-align:left;text-transform:none;border:2px solid #ED7D31;border-radius:50px 50px 50px 50px;margin-left:0px;padding-right:60px;padding-bottom:0px;padding-left:60px;}
body.kc-css-system .kc-css-5877124 .caldera-grid input.btn:hover{color:#ffffff;background:#ED7D31;}
body.kc-css-system .kc-css-5877124 input:focus{box-shadow:none;border:1px solid #ED7D31;}
body.kc-css-system .kc-css-5877124 textarea:focus{box-shadow:none;border:1px solid #ED7D31;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-5484550 .deb:before{display:none;}
body.kc-css-system .kc-css-5484550 .deb:after{display:none;}
body.kc-css-system .kc-css-5877124 input{margin-top:10px!important;margin-bottom:10px!important;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-422242{display:none;}
body.kc-css-system .kc-css-469547{display:none;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-5484550 .deb:before{padding-left:345px;}
body.kc-css-system .kc-css-5484550 .deb:after{padding-right:345px;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-311746{padding-top:80px;padding-bottom:80px;}
body.kc-css-system .kc-css-5484550 .t4{margin-top:0px;}
body.kc-css-system .kc-css-5484550 .t5{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-5877124 textarea{margin-top:0px;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/GetInTouch.vue